// extracted by mini-css-extract-plugin
module.exports = {"switch":"toggle_switch__3FYZR","slider":"toggle_slider__3yT8w"};